<template>
  <v-card v-if="isAdmin" tile>
    <v-card-title>
      <v-dialog v-model="dialog" max-width="900px">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" color="primary" dark class="ma-2">Ajouter un nouveau référent</v-btn>
        </template>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-row>
                  <v-col cols="12" md="4">
                    <v-text-field
                      name="input-7-1"
                      label="* Organisation:"
                      v-model="assistant.society"
                      required
                      :rules="[() => !!assistant.society || 'Champ obligatoire']"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      name="input-7-1"
                      label="* Prénom et Nom:"
                      v-model="assistant.name"
                      required
                      :rules="[() => !!assistant.name || 'Champ obligatoire']"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field
                      name="input-7-1"
                      label="* Email:"
                      v-model="assistant.email"
                      required
                      :rules="[() => !!assistant.email || 'Champ obligatoire']"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field
                      name="input-7-1"
                      label="* Téléphone:"
                      v-model="assistant.mobile"
                      required
                      :rules="[() => !!assistant.mobile || 'Champ obligatoire']"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field label="Téléphone 2" v-model="assistant.mobile2"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field name="input-7-1" label="Adresse:" v-model="assistant.address"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select
                      :items="['EVAM', 'DGCS', 'DIRIS', 'DGEP', 'BLI', 'BCI - DEIEP']"
                      label="Mandat"
                      v-model="assistant.mandat"
                      clearable
                    ></v-select>
                  </v-col>

                  <v-col cols="12">
                    <v-textarea outlined name="input-7-1" label="Commentaire" v-model="assistant.comment"></v-textarea>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click.native="close">Annuler</v-btn>
              <v-btn color="blue darken-1" :disabled="isDisabled" text @click.native="save">Sauvegarder</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-card-title>
    <v-card-title>
      RÉFÉRENTS
      <v-spacer></v-spacer>
      <v-text-field 
        v-model="search" 
        append-icon="mdi-magnify" 
        :append-outer-icon="search ? 'mdi-close' : ''"
        @click:append-outer="clearSearch"
        label="Chercher" 
        single-line 
        hide-details
        clearable
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="assistants"
      :loading="loading"
      :items-per-page="200"
      :search="search"
      :footer-props="{
        itemsPerPageText: 'Nombre de lignes',
        pageText: 'Lignes {0}-{1} de {2}',
      }"
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td>{{ item.society }}</td>
            <td>{{ item.mandat }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.mobile }}</td>
            <td>{{ item.mobile2 }}</td>
            <td>{{ item.comment }}</td>
            <td class="spacy">
              <v-btn text icon color="green" @click="editItem(item)">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn text icon color="red" @click="deleteItem(item)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import Assistant from "@/models/Assistant"
import { mapGetters } from "vuex"

export default {
  data() {
    return {
      search: "",
      headers: [
        { text: "Organisation", value: "society" },
        { text: "Mandat", value: "mandat" },
        { text: "Nom", value: "name" },
        { text: "Email", value: "email" },
        { text: "Téléphone ", value: "mobile" },
        { text: "Téléphone_2", value: "mobile2" },
        { text: "Commentaire", value: "comment" },
        { text: "Action", sortable: false },
      ],
      infos: [],
      info: {},
      loading: true,
      edit: false,
      editing: null,
      assistant: new Assistant(),
      defaultItem: new Assistant(),
      dialog: false,
      valid: false,
    }
  },
  async mounted() {
    await Assistant.get().finally(() => {
      this.loading = false
    })
    
    // Set search from query parameter if provided
    if (this.$route.query.search) {
      this.search = this.$route.query.search
    }
  },
  computed: {
    ...mapGetters("Auth", ["isAdmin"]),
    assistants() {
      return Assistant.query().all()
    },
    formTitle() {
      return this.assistant.id ? "Modifier un référent" : "Ajouter un nouveau référent"
    },
    isDisabled() {
      return !this.assistant.society || !this.assistant.name || !this.assistant.email || !this.assistant.mobile
    },
  },
  methods: {
    getDataFromApi() {
      Assistant.get().finally(() => {
        this.loading = false
      })
    },
    editItem(item) {
      this.assistant = new Assistant(item)
      this.dialog = true
    },
    deleteItem(item) {
      confirm("Are you sure you want to delete this item?") && Assistant.deleteOne(item.id)
    },
    close() {
      this.dialog = false
      setTimeout(() => {
        this.assistant = new Assistant()
      }, 300)
    },

    save() {
      if (this.assistant.id) {
        Assistant.put(this.assistant)
      } else {
        Assistant.post(this.assistant)
      }
      this.close()
    },
    clearSearch() {
      this.search = ""
      // Update URL to remove search parameter
      this.$router.replace({ query: {} })
    },
  },
  watch: {
    '$route.query.search'(newSearch) {
      if (newSearch) {
        this.search = newSearch
      }
    }
  },
  filters: {
    dateToHuman(date) {
      let d = new Date(date)
      return ("0" + d.getDate()).slice(-2) + "/" + ("0" + Number(d.getMonth() + 1)).slice(-2) + "/" + d.getFullYear()
    },
  },
}
</script>
<style scoped>
.spacy {
  min-width: 200px;
}
</style>
